import List from "@mui/material/List";
import React from "react";

/**
 * A super-basic wrapper for the MUI List component, in case we want to extend it
 */

const DSList = ({ children, ...props }) => <List {...props}>{children}</List>;

export default React.memo(DSList);
